// src/routes.tsx
import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "../pages/home";
import Layout from "../components/layouts/layout";
import Leaguetable from "../pages/league-table";
import Clubprofile from "../pages/club-profiles";
import Analytics from "../pages/analytics";
import ClubProfileDetails from "../pages/club-profiles/profile-details";
import NotFound from "../pages/not-found";

const teamsData = [
  { id: 1, name: "Arsenal FC", country: "England", score: 98.5 },
  { id: 2, name: "Barcelona", country: "Spain", score: 96.2 },
  { id: 3, name: "Bayern Munich", country: "Germany", score: 94.8 },
  { id: 4, name: "Juventus", country: "Italy", score: 92.1 },
  { id: 5, name: "PSG", country: "France", score: 90.3 },
  { id: 6, name: "Chelsea", country: "England", score: 88.7 },
  { id: 7, name: "Real Madrid", country: "Spain", score: 97.9 },
  { id: 8, name: "Liverpool", country: "England", score: 89.6 },
  { id: 9, name: "AC Milan", country: "Italy", score: 85.2 },
];

export default function AppRoutes() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/league-table" element={<Leaguetable />} />

        {/* ✅ pass actual teamsData instead of [] */}
        <Route path="/club-profile" element={<Clubprofile />} />

        <Route
          path="/club-profile/details"
          element={<ClubProfileDetails />}
        />
        <Route path="/analytics" element={<Analytics />} />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
